<template>
<div class="form-container" :style="{
      background: '#fff',
      height: '100%'
    }">
  <a-row type="flex" justify="start" class="baseInfo">
    <p class="label">联系人：</p>
    <a-row type="flex" v-if="isEditName">
      <p class="value">{{userInfo.worksheetContacter}}</p>
      <div class="actions">
        <span class="status">已认证</span>
        <a-divider type="vertical" />
        <a @click="handleChangeName">修改</a>
      </div>
    </a-row>
    <a-row v-else type="flex" justify="start">
      <a-form-model labelAlign="left" :rules="rules" ref="form" :model="userInfo">
        <a-form-model-item prop="worksheetContacter">
          <a-input v-model.trim="userInfo.worksheetContacter" style="width:232px;" placeholder="请输入联系人真实姓名" type="nickname" />
        </a-form-model-item>
      </a-form-model>

      <a-button type="primary" style="margin:0 24px 0 40px;" @click="saveUserInfo('form')">保存</a-button>
      <a-button @click="handleChangeName">取消</a-button>
    </a-row>
  </a-row>

  <a-row type="flex" justify="start" class="baseInfo">
    <p class="label">单位名称：</p>
    <a-row type="flex" v-if="isEditCompany">
      <p class="value">{{userInfo.worksheetCompanyName}}</p>
      <div class="actions">
        <span class="status">已认证</span>
        <a-divider v-if="EditUserCompanyRole" type="vertical" />
        <a v-if="EditUserCompanyRole" @click="handleChangeCompanyName">变更单位名称</a>
        <eco-icon name="tips" :size="14" style="margin-left:40px;margin-right:6px;color:#FFC069"></eco-icon>
        <span>用户一年可修改一次</span>
      </div>
    </a-row>
    <a-row v-else type="flex" justify="start">
      <a-form-model labelAlign="left" :rules="rules" ref="formCompany" :model="userInfo">
        <a-form-model-item prop="worksheetCompanyName">
          <a-input v-model.trim="userInfo.worksheetCompanyName" style="width:232px;" placeholder="请输入单位名称" />
        </a-form-model-item>
      </a-form-model>

      <a-button type="primary" style="margin:0 24px 0 40px;" @click="saveCompanyName('formCompany')">保存</a-button>
      <a-button @click="handleChangeCompanyName">取消</a-button>
      
      <span><eco-icon name="tips" :size="14" style="margin-left:40px;margin-right:6px;color:#FFC069"></eco-icon>用户一年可修改一次</span>
    </a-row>
  </a-row>

  <a-row type="flex" justify="start" class="baseInfo">
    <p class="label">邮箱：</p>
    <a-row type="flex" v-if="isEditEmail">
      <p class="value" style="line-break: anywhere;">{{userInfo.worksheetEmail}}</p>
      <div class="actions">
        <span class="status">已认证</span>
        <a-divider type="vertical" />
        <a @click="handleChangeEmail">修改</a>
      </div>
    </a-row>
    <a-row v-else type="flex" justify="start">
      <a-form-model labelAlign="left" :rules="rules" ref="form" :model="userInfo">
        <a-form-model-item prop="worksheetEmail">
          <a-input v-model.trim="userInfo.worksheetEmail" style="width:232px;" placeholder="请输入常用邮箱" />
        </a-form-model-item>
      </a-form-model>

      <a-button type="primary" style="margin:0 24px 0 40px;" @click="saveUserEmail('form')">保存</a-button>
      <a-button @click="handleChangeEmail">取消</a-button>
    </a-row>
  </a-row>

  <a-row type="flex" justify="start" class="baseInfo">
    <p class="label">手机号：</p>
    <a-row type="flex">
      <p class="value">{{userInfo.phone}}</p>
      <div class="actions">
        <span class="status">已认证</span>
      </div>
    </a-row>
  </a-row>
</div>
</template>

<script>
import {
  verifyRealName,
  editUserInfo,
  editUserCompanyInfo,
  hasEditUserCompanyInfo
} from "@/request/user";
import {
  user,
  model
} from "eco-cli";
const {
  getToken,
  login,
  getInfo,
  setToken
} = user
const Image = model.Image;
const User = model.UserInfo;

export default {
  components: {},
  props: [],
  mixins: [],
  computed: {
    rules() {
      return {
        worksheetCompanyName: [{
            required: true,
            message: "请输入单位名称！",
            trigger: "change",
          },
          {
            max: 50,
            message: "输入内容字符已达上限50个字符",
            trigger: ["blur", "change"]
          }
        ],
        worksheetContacter: [{
            required: true,
            message: "请输入联系人真实姓名！",
            trigger: "change",
          },
          {
            max: 5,
            message: "输入内容字符已达上限5个字符",
            trigger: ["blur", "change"]
          }
        ],
        worksheetEmail: [
          {
            required: true,
            message: '请输入常用邮箱',
            trigger: 'change',
          },
          {
            max: 320,
            message: "邮箱长度超出限制！",
            trigger: ["blur", "change"]
          },
          {
            pattern: /^[a-z0-9A-Z][- | a-z0-9A-Z . _]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "请输入正确的邮箱地址！",
            trigger: "blur",
          }
        ],
      };
    },
  },

  data() {
    return {
      userInfo: {
        worksheetContacter: "",
        worksheetCompanyName: "",
        worksheetEmail: ""
      },
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 16
      },
      headers: {},
      type: "selectable",
      token: '',
      isSave: false,
      isWorksheetRole: false,
      isEditName: true,
      isEditCompany: true,
      isEditEmail: true,
      EditUserCompanyRole: true,
    };
  },
  // beforeCreate() {
  //   document.querySelector("body").setAttribute("style", "overflow-y:auto");
  // },
  // beforeDestroy() {
  //   document.body.removeAttribute("style");
  // },
  mounted() {
    getToken().then((res) => {
      this.token = res;
      this.headers = {
        "X-Access-Token": res
      };
    })
    getInfo(true).then(res => {
      console.log("currentUser", res)
      this.userInfo = res;
    });
    
    hasEditUserCompanyInfo().then((res)=>{
      this.EditUserCompanyRole = res;
    })
  },
  methods: {
    // 更改用户名
    handleChangeName() {
      this.isEditName = !this.isEditName;

      getInfo(true).then(res => {
        this.userInfo = res;
      });
    },
    // 更改单位名称
    handleChangeCompanyName() {
      this.isEditCompany = !this.isEditCompany;

      getInfo(true).then(res => {
        this.userInfo = res;
      });
    },
    // 更改邮箱
    handleChangeEmail() {
      this.isEditEmail = !this.isEditEmail;

      getInfo(true).then(res => {
        this.userInfo = res;
      });
    },
    saveCompanyName(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const h = this.$createElement;
          this.$confirm({
            title: '提示',
            icon: () => h('a-icon', {
              props: {
                type: 'question-circle',
              },
              style: {
                color: '#faad14'
              }
            }),
            content: h('div', {}, [
              h('p', {
                domProps: {
                  innerHTML: `单位名称一年内仅可修改一次，是否确认修改？`
                },
                style: {
                  fontSize: '14px',
                  color: 'rgba(0,0,0,.65)'
                }
              }),
            ]),
            okText: "确认",
            cancelText: "取消",
            centered: true,
            onOk: () => {
              editUserCompanyInfo({
                  companyName: this.userInfo.worksheetCompanyName
                })
                .then((res) => {
                  console.log(`res: `, res);
                  this.$message.success("保存成功！");
                  this.userInfo.companyName = res.worksheetCompanyName;
                  setToken(this.token, this.userInfo);
                  this.isEditCompany = true;
                  this.EditUserCompanyRole = false;
                  // setTimeout(() => {
                  //   window.location.reload();
                  // }, 2000)
                })
                .finally(() => {
                  // this.isSave = false;
                })
            },
          });
        } else {
          return false;
        }
      })

    },
    saveUserInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.isSave = true;
          editUserInfo({
              productContact: this.userInfo.worksheetContacter
            })
            .then((res) => {
              console.log(`res: `, res);
              this.$message.success("保存成功！");
              this.userInfo.worksheetContacter = res.worksheetContacter
              setToken(this.token, this.userInfo);
            })
            .finally(() => {
              this.isEditName = true;
            })
        } else {
          return false;
        }
      });
    },
    saveUserEmail(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.isSave = true;
          editUserInfo({
              productEmail: this.userInfo.worksheetEmail
            })
            .then((res) => {
              this.$message.success("保存成功！");
              this.userInfo.worksheetEmail = res.worksheetEmail
              setToken(this.token, this.userInfo);
            })
            .finally(() => {
              this.isEditEmail = true;
            })
        } else {
          return false;
        }
      });
    },
    // 验证重命名
    validateRealName(rule, value, callback) {
      let timer = null;
      var that = this;
      return (function () {
        clearTimeout(timer);
        timer = setTimeout(() => {
          that.checkName(rule, value, callback);
        }, 300);
      })();
    },
    checkName(rule, value, callback) {
      if (!value || value.length < 2 || value.length > 10) {
        return;
      }
      verifyRealName(value).then((res) => {
        if (res) {
          callback(new Error("昵称已被占用，请更换其它昵称"));
        } else {
          callback();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container ::v-deep .ant-form label {
  font-size: 16px !important;
}

.form-container ::v-deep .ant-form-item-label {
  margin-right: 12px;
}

.form-container {
  // display: flex;
  // display: -webkit-flex;
  // align-items: center;
  // justify-content: center;
  padding: 50px 0 0 70px;

  .baseInfo {

    font-size: 14px;
    font-weight: 400;
    line-height: 32px;
    margin-bottom: 30px;

    .label {
      color: #222222;
      margin-right: 5px;
      line-height: 32px;
      width: 100px;
      text-align: right;
    }

    .value {
      color: #777777;
      line-height: 32px;
      width: 272px;
    }

    .actions {
      .status {
        font-size: 14px;
        font-weight: 400;
        color: #777777;
        line-height: 20px;
      }

      a {
        color: #4771F8;
      }
    }
  }

}
</style>
